var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"schedule"},[(_vm.is1yuan)?_c('schedule-list2',{attrs:{"page":"schedule","dataSource":_vm.dataSource},on:{"fold":_vm.handleFoldSection}}):_c('schedule-list',{attrs:{"page":"schedule","dataSource":_vm.dataSource,"has-buy":true},on:{"fold":_vm.handleFoldSection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }